import {Component, EventEmitter, forwardRef, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {ControlValueAccessor, FormControl, FormGroup, NG_VALIDATORS, NG_VALUE_ACCESSOR} from '@angular/forms';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {TranslateService} from '@ngx-translate/core';
import {ND, WidgetValidator} from '@pt/pt-models';
import {ValidatorGenerator} from '../../utils/validator-generator';

@Component({
  selector: 'pt-treatment-input-risk',
  templateUrl: './treatment-input-risk.component.html',
  styleUrls: ['./treatment-input-risk.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => TreatmentInputRiskComponent)
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => TreatmentInputRiskComponent),
      multi: true
    }
  ]
})
export class TreatmentInputRiskComponent implements OnInit, OnDestroy, ControlValueAccessor {
  @Input() controlName: string;
  @Input() label: string;
  @Input() validators: WidgetValidator[];

  @Input() enabled: boolean;
  @Output() riskAssessment = new EventEmitter();


  public formGroup: FormGroup;
  isDisabled = false;
  isChanged = false;
  isRequired: boolean;
  inputId: string;
  private destroy$: Subject<boolean> = new Subject<boolean>();
  private onChanged: (val) => void;
  private onTouched: () => void;

  constructor(private translateService: TranslateService) {
  }


  ngOnDestroy(): void {
    this.isRequired = ValidatorGenerator.validatorsContainsRequired(this.validators);

    this.destroy$.next(true);
  }

  ngOnInit(): void {
    this.inputId = 'riskAssessment_' + this.controlName;

    this.setFormGroup();

    this.formGroup.valueChanges.pipe(
      takeUntil(this.destroy$)
    ).subscribe(t => {
      this.isChanged = t.value !== null;

      if (this.onChanged) {
        this.onChanged(t ? t.value : t);
      }
      if (this.onTouched) {
        this.onTouched();
      }
    });
  }

  writeValue(obj: any): void {
    if (obj) {
      this.formGroup.controls.value.setValue(obj);
    } else {
      this.translateService.stream('LABELS.NONE').subscribe(
        (value) => {
          this.formGroup.controls.value.setValue(value);
        }, (error) => {
          this.formGroup.controls.value.setValue(ND);
        }
      );
    }
  }

  registerOnChange(fn: any): void {
    this.onChanged = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
    if (isDisabled) {
      this.formGroup.controls.value.disable();
    } else {
      this.formGroup.controls.value.enable();
    }
  }

  validate(value: FormControl) {
    return this.formGroup.invalid && {
      invalid: true
    };
  }

  private setFormGroup() {
    this.formGroup = new FormGroup({
      value: new FormControl(null)
    });
  }
}
